import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../Users/StaffUser/_redux/staffUserActions";

// ---------- API permission -> cardId ----------
const permissionMap = {
  "newreports.dashboard.list": "dashboard",
  "newreports.contestReport.list": "contestReport",
  "newreports.contestuserReport.list": "contestuserReport",
  "newreports.tournamentReport.list": "tournamentReport",
  "newreports.subscriptionReport.list": "subscriptionReport",
  "newreports.coinstoreReport.list": "coinstoreReport",
  "newreports.userReport.list": "userReport",
  "newreports.banneradslog.list": "banneradslog",
};

// ---------- Cards ----------
const reportCards = [
  { _id: "dashboard", icon: "fa-chart-line", bgColor: "bg-light-info",  iconColor: "text-success", title: "Dashboard", subtitle: "Overview" },
  { _id: "contestReport", icon: "fa-chart-line", bgColor: "bg-light-success", iconColor: "text-success", title: "Contest Report", subtitle: "Game Play" },
  { _id: "contestuserReport", icon: "fa-users", bgColor: "bg-light-danger", iconColor: "text-danger", title: "Contest User Report", subtitle: "Game Play" },
  { _id: "tournamentReport", icon: "fa-users", bgColor: "bg-light-success", iconColor: "text-info", title: "Tournament Report", subtitle: "Game Play" },
  { _id: "subscriptionReport", icon: "fa-coins", bgColor: "bg-light-info", iconColor: "text-info", title: "Subscription Report", subtitle: "Financial" },
  { _id: "coinstoreReport", icon: "fa-coins", bgColor: "bg-light-warning", iconColor: "text-warning", title: "Coins Store Report", subtitle: "Financial" },
  { _id: "userReport", icon: "fa-users", bgColor: "bg-light-danger", iconColor: "text-danger", title: "User Report", subtitle: "User Report" },
  { _id: "banneradslog", icon: "fa-bullhorn", bgColor: "bg-light-success", iconColor: "text-info", title: "Banner Ads - Logs", subtitle: "Banner Ads - Logs" },
];
const colors = [
  "#D6EAF8", // Medium Primary Blue
  "#D5F5E3", // Medium Teal (Success)
  "#FAD7A0", // Medium Purple/Indigo
  "#E8DAEF", // Medium Info Blue
  "#F5B7B1", // Medium Danger Red
  "#D1F2EB", // Medium Warning Orange
  "#F2F3F4", // Medium Gray/Slate
];

const companywiseLinks = {
  Vi: {
    dashboard: "/viDashboard/list",
    contestReport: null,
    tournamentReport: "/viDashboard/TournamnetTransaction/list",
    contestuserReport: "/viDashboard/ContestTransaction/list",
    subscriptionReport: "/viDashboard/SubscriptionTransaction/list",
    coinstoreReport: "/viDashboard/CoinStoreTransaction/list",
  },
  AM: {
    dashboard: "/ampereDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  BS: {
    dashboard: "/bisbDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  BCP: {
    dashboard: null,
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  D11: {
    dashboard: "/d11Dashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  EP: {
    dashboard: "/easyPaisaDashboard/list",
    contestReport: "/easyPaisaDashboard/contestReport",
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  GJ: {
    dashboard: "/gamerjiDashboard/list",
    banneradslog: "/gamerjiDashboard/bannerloglist",
    contestReport: "/contests/contests-reports",
    tournamentReport: "/gamerjiDashboard/TournamnetTransaction/list",
    contestuserReport: "/gamerjiDashboard/ContestTransaction/list",
    subscriptionReport: "/gamerjiDashboard/SubscriptionTransaction/list",
    coinstoreReport: "/gamerjiDashboard/CoinStoreTransaction/list",
    userReport: "/gamerjiDashboard/gamerjiUserReport"
  },
  GLO: {
    dashboard: "/gloDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  GP: {
    dashboard: "/goPlayDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  JZ: {
    dashboard: "/jazzDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  IG: {
    dashboard: "/indggDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  ME: {
    dashboard: "/mobilyDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  om: {
    dashboard: null,
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  OP: {
    dashboard: "/ooredooDashboard/list",
    contestReport: null,
    // tournamentReport: "/ooredooDashboard/TournamnetTransaction/list",
    // contestuserReport: "/ooredooDashboard/ContestTransaction/list",
    // subscriptionReport: "/ooredooDashboard/SubscriptionTransaction/list",
    // coinstoreReport: "/ooredooDashboard/CoinStoreTransaction/list",
  },
  RE: {
    dashboard: null,
    contestReport: "/r11Dashboard/ContestReport",
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  SCP: {
    dashboard: null,
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  TLB: {
    dashboard: "/talabatDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  VC: {
    dashboard: null,
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  EG: {
    dashboard: null,
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
  SC: {
    dashboard: "/safaricomDashboard/list",
    contestReport: null,
    contestuserReport: null,
    subscriptionReport: null,
    coinstoreReport: null,
  },
};


const FirstCard = () => {
  const dispatch = useDispatch();

  const { companyDropdownList, roleList } = useSelector(
    (state) => ({
      companyDropdownList: state.staffUsers?.companyDropdownList,
      // IMPORTANT: reducer should set this on actions.roleFetched({ roleList })
      roleList: state.staffUsers?.roleList,
    }),
    shallowEqual
  );

  const [companyArray, setCompanyArray] = useState([]);
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  const formatDateTime = (date) => moment(date).format("DD MMM YYYY, hh:mm A");

  // Load companies + permissions (to Redux)
  useEffect(() => {
    dispatch(actions.fetchCompanyLastActiveList());
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.id) {
      // NO await — Option 2: reducer will update roleList
      dispatch(actions.fetchRolePermissions({ userId: userData.id, forEdit: true }));
    }
  }, [dispatch]);

  // Build company list (always visible; restrict by userData.company if present)
  useEffect(() => {
    const all = companyDropdownList?.data || [];
    const userData = JSON.parse(localStorage.getItem("userData"));
    const allowed = userData?.company || null;

    const base = allowed ? all.filter((c) => allowed.includes(c._id)) : all;

    const sorted = [...base].sort((a, b) => {
      const aLinks = Object.values(companywiseLinks[a?.code] || {}).filter(Boolean).length;
      const bLinks = Object.values(companywiseLinks[b?.code] || {}).filter(Boolean).length;
      return bLinks - aLinks;
    });

    setCompanyArray(sorted);
  }, [companyDropdownList]);

  // Build permissionsByCompany from Redux roleList
  const permissionsByCompany = useMemo(() => {
    const out = {};
    const list = Array.isArray(roleList?.data) ? roleList.data : Array.isArray(roleList) ? roleList : [];
    list.forEach((item) => {
      const cids = item?.company || [];
      const allPerms = [
        ...(item?.buttonPermission || []),
        ...(item?.pagePermission || []),
        ...(item?.apiPermission || []),
      ];
      cids.forEach((cid) => {
        if (!out[cid]) out[cid] = new Set();
        allPerms.forEach((p) => out[cid].add(p));
      });
    });
    return out;
  }, [roleList]);

  const toggleSection = (idx) =>
    setExpandedIndexes((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]));

  const getPermKeyForCard = (cardId) =>
    Object.keys(permissionMap).find((k) => permissionMap[k] === cardId);

  const hasPermissionForCompany = (companyId, cardId) => {
    const set = permissionsByCompany[companyId];
    if (!set) return false;
    const key = getPermKeyForCard(cardId);
    return key ? set.has(key) : false;
  };

  return (
    <>
      {companyArray?.map((company, index) => {
        const isExpanded = expandedIndexes.includes(index);
        const cardColor = colors[index % colors.length];
        const linksForCompany = companywiseLinks[company?.code];

        return (
          <div
            key={company?._id || index}
            className="card card-custom gutter-b user_profile_card_border"
            style={{ borderRadius: "16px" }}
          >
            {/* Header */}
            <div
              className="card-header ribbon ribbon-clip ribbon-right"
              style={{
                backgroundColor: cardColor,
                borderRadius: isExpanded ? "16px 16px 0 0" : "16px",
                transition: "border-radius 1s",
              }}
            >
              <div className="card-title w-100 d-flex flex-wrap align-items-center justify-content-between" style={{ color: "#233a55" }}>
                <div className="d-flex flex-wrap gap-5">
                  <div className="d-flex align-items-center mr-14">
                    <i className="fa fa-gamepad mr-6" style={{ fontSize: "25px", color: "#233a55" }} />
                    <div>
                      <div className="font-weight-bold" style={{ fontSize: "20px", color: "#233a55" }}>
                        {company?.name}
                      </div>
                      <div className="font-size-sm" style={{ color: "#233a55" }}>Company Name</div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mr-14">
                    <i className="fa fa-user mr-6" style={{ fontSize: "25px", color: "#233a55" }} />
                    <div>
                      <div className="font-weight-bold" style={{ fontSize: "20px", color: "#233a55" }}>
                        {company?.isShared === true ? "Shared" : "Non-Shared"}
                      </div>
                      <div className="font-size-sm" style={{ color: "#233a55" }}>Type</div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mr-14">
                    <i className="flaticon-chat-1 mr-6" style={{ fontSize: "25px", color: "#233a55" }} />
                    <div>
                      <div className="font-weight-bold" style={{ fontSize: "20px", color: "#233a55" }}>
                        {company?.createdAt ? moment(company.createdAt).format("DD MMM YYYY, hh:mm A") : "-"}
                      </div>
                      <div className="font-size-sm" style={{ color: "#233a55" }}>Start Date</div>
                    </div>
                  </div>
                </div>

                <div className="ml-auto">
                  <i
                    className={`fas ${isExpanded ? "fa-chevron-circle-up" : "fa-chevron-circle-down"} icon-2x`}
                    style={{ cursor: "pointer", color: "#233a55", borderRadius: "50%", padding: "8px" }}
                    onClick={() => toggleSection(index)}
                  />
                </div>
              </div>
            </div>

            {/* Body */}
            <div
              className="card-body"
              style={{
                padding: isExpanded ? "20px 20px 0 20px" : "0px",
                maxHeight: isExpanded ? "1000px" : "0px",
                overflow: "hidden",
                transition: "padding 0.5s, max-height 0.5s",
              }}
            >
              <div className="row">
                {!linksForCompany && (
                  <div className="col-12 mb-4 text-muted">No routes configured for this company code ({company?.code}).</div>
                )}

                {linksForCompany &&
                  reportCards
                    .filter((card) => {
                      const hasPerm = hasPermissionForCompany(company?._id, card._id);
                      const hasLink = !!linksForCompany?.[card._id];
                      return hasPerm && hasLink;
                    })
                    .map((card) => (
                      <div
                        key={`${company?._id}-${card._id}`}
                        className="col-12 col-md-6 col-xl-4 mb-5"
                        onClick={() => window.open(linksForCompany[card._id], "_blank")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={`card card-custom ${card.bgColor} card-stretch`}>
                          <div className="card-body">
                            <i className={`fa ${card.icon} ${card.iconColor} mb-4`} style={{ fontSize: "2rem" }} />
                            <div className="font-weight-bolder text-dark-75 font-size-h5">{card.title}</div>
                            <div className="font-weight-bold text-muted font-size-sm">{card.subtitle}</div>
                          </div>
                        </div>
                      </div>
                    ))}

                {linksForCompany &&
                  reportCards.filter((card) => {
                    const hasPerm = hasPermissionForCompany(company?._id, card._id);
                    const hasLink = !!linksForCompany?.[card._id];
                    return hasPerm && hasLink;
                  }).length === 0 && (
                    <div className="col-12 mb-4 text-muted">No cards available for your permissions.</div>
                  )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FirstCard;
